import { SelectedAccountDisputeNext } from "./selected-account-dispute-next.model";

export class RaiseDisupteAccount {
  TransUnion: Array<SelectedAccountDisputeNext>;
  Experion: Array<SelectedAccountDisputeNext>;
  Equifax: Array<SelectedAccountDisputeNext>;
  Creditors: Array<SelectedAccountDisputeNext>;
  OtherBureau: Array<SelectedAccountDisputeNext>;
}



// export class SelectedAccount {
//   public AccountNames: string;
//   public TemplateNames: string;
//   public Included: string
//   public AttachmentId: number;
//   public SelectedSections: Array<SelectedSection>;
// }

// export class SelectedSection {
//   public SelectedSectionId: number;
//   public AccIssue: string;
//   public AccIssueId: number;
//   public TemplateFolder: string
//   public TemplateFolderId: number
//   public Template: string
//   public TemplateId: number;
//   public ReasonCategory: string;
//   public ReasonCategoryId: number;
//   public ShortDescription: string;
//   public ShortDescriptionId: number;
//   public Description: string;
// }


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/models/contact/raise-disupte-account.model.ts